import { commitMutation, graphql } from "react-relay";
import environment from "../../AuthEnv";
// import { GC_USER_ID, GC_AUTH_TOKEN } from "../constants";

const mutation = graphql`
  mutation CreateStripeSessionMutation(
    $priceId: String!
    $currency: String!
    $unit_amount: Int!
    $interval: String!
    $trial: Boolean
  ) {
    createStripeSession(
      priceId: $priceId
      currency: $currency
      unitAmount: $unit_amount
      interval: $interval
      trial: $trial
    ) {
      stripeSession {
        session_id
      }
    }
  }
`;

export default (priceId, currency, unit_amount, interval, trial, callback) => {
  const variables = {
    priceId: priceId,
    currency: currency,
    unit_amount: unit_amount,
    interval: interval,
    trial: trial
  };

  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      // if (response.createStripeSession.stripeSession != null) {
      if (response.createStripeSession) {
        const sessionId = response.createStripeSession.stripeSession.session_id;
		console.log(response);
        callback(sessionId);
      } else {
        console.log("Error commiting stripe session mutation!");
      }
      // }
      // else {
      // 	console.log("Subscription already exists!");
      // }
    },
    onError: (err) => console.error(err),
  });
};
